module.exports = __webpack_public_path__ + "static/media/HarunLogo.b9c00f1b.png";